import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Fade, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';

const propTypes = {
  onChange: PropTypes.func,
};
const defaultProps = {
  onChange: null,
};

export default function LeftSideMenu(props) {
  const { onChange } = props;
  const [selectedLink, setSelectedLink] = useState('');
  const location = useLocation();
  const pages = [
    {
      title: 'Partners',
      path: '/partners',
    },
    {
      title: 'Tiers',
      path: '/tiers',
    },
    {
      title: 'Specialties',
      path: '/competencies',
    },
    // {
    //   title: 'Templates',
    //   path: '/templates',
    // },
  ];
  const onLinkClick = (e, path, title) => {
    setSelectedLink(path);
    if (onChange) {
      onChange(title);
      document.title = `${title} | PMI Partner Portal`;
    }
  };
  const isSelected = (path) => selectedLink.startsWith(path);
  useEffect(() => {
    pages.map((p) => {
      if (location.pathname.startsWith(p.path.toLowerCase())) {
        setSelectedLink(p.path);
        if (onChange) {
          onChange(p.title);
        }

        return p;
      }

      return p;
    });
  });

  return (
    <div className="left-side-menu">
      <Fade in>
        <Nav className="nav-pills nav-fill flex-lg-column flex-md-column flex-sm-row ">
          {pages.map((p, i) => (
            <Nav.Link
              key={`side-link-${i.toString()}`}
              as={Link}
              className={
                isSelected(`${p.path}`)
                  ? 'active rounded-0 text-start text-lg-start text-md-center text-sm-center '
                  : 'text-start text-lg-start text-md-center text-sm-center '
              }
              to={p.path}
              onClick={(e) => onLinkClick(e, p.path, p.title)}
              data-testid="Link-page"
            >
              <span>{p.title}</span>
            </Nav.Link>
          ))}
        </Nav>
      </Fade>
    </div>
  );
}

LeftSideMenu.propTypes = propTypes;
LeftSideMenu.defaultProps = defaultProps;
